import * as Sentry from '@sentry/react'

import { env } from './env'
import { currentBuildMeta } from './build-meta'
import { isChunkLoadError } from './chunk-load-error'

export function initSentry() {
  if (!env.sentryDsn) return

  Sentry.init({
    dsn: env.sentryDsn,
    environment: env.sentryEnvironment,
    release: currentBuildMeta.buildId,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: env.isProduction ? 0.1 : 1,
    beforeSend: dropChunkLoadErrors
  })
}

export function dropChunkLoadErrors<T extends Sentry.ErrorEvent>(
  event: T,
  hint: Sentry.EventHint
): T | null {
  if (isChunkLoadError(hint.originalException)) return null
  const values = event.exception?.values ?? []
  if (values.some(value => isChunkLoadError(value.value))) return null
  return event
}

export { Sentry }
